import {
  FormikProps,
  ProductsSequence,
  type ProductsSequenceProduct,
  type ProgressBar,
  type TimeFrameObject
} from 'common/contracts';

export interface ProgressBarFormProps {
  edit?: boolean;
  dup?: boolean;
}

export interface ProductProps {
  _id: string;
  productId: string;
  image: string;
  imagePrefix: string;
  name: string;
  amount: number | string;
  type: string;
  textFontColorHex: string;
  prefix: string;
  suffix: string;
  publisherProductId?: string;
  quantityDisplay: string;
  priority?: string;
}

export interface TabsProps extends ProgressBarFormProps {
  formikProps: FormikProps;
  progressBarId?: string;
  productsSequence: ProductsSequence[];
  setProductsSequence: React.Dispatch<React.SetStateAction<ProductsSequence[]>>;
  hasMissingProductDetails?: boolean;
  products?: ProductProps[];
  setProducts?: (products: ProductProps[]) => void;
  setDirtyProducts?: (isDirty: boolean) => void;
  setCurrentProduct?: (product: ProductsSequenceProduct | null) => void;
  isLoadingProducts?: boolean;
}

export type RowData = {
  publisherOfferId: string;
  offerId: string;
  productsSequence: ProductsSequence[];
  status: string;
  active: boolean;
  schedule?: {
    permanent: boolean;
    interval?: string;
    timeFrames?: TimeFrameObject[];
  };
  offerUi?: {
    offerUiId?: string;
    _id?: string;
    active: boolean;
    offerUiType: string;
    name: string;
    description: string;
    backgroundImage: string;
    progressBar: ProgressBar;
  };
};

export enum EProgressBarTabs {
  SETTINGS = 'Settings',
  CONFIGURATION = 'Configuration',
  SCHEDULE = 'Schedule'
}
